(function(){
  function initRootCart(){
    var form=document.querySelector('[data-root-cart-form]');
    if(!form)return;
    var updateButton=form.querySelector('[data-root-cart-update]');
    var timer=null;
    var submitting=false;

    function submitUpdate(){
      if(submitting)return;
      submitting=true;
      if(form.requestSubmit && updateButton){
        form.requestSubmit(updateButton);
      }else{
        form.submit();
      }
    }

    function scheduleUpdate(){
      window.clearTimeout(timer);
      timer=window.setTimeout(submitUpdate,420);
    }

    form.querySelectorAll('[data-root-qty]').forEach(function(stepper){
      var input=stepper.querySelector('.root-qty__input');
      if(!input)return;
      stepper.querySelectorAll('[data-qty-action]').forEach(function(button){
        button.addEventListener('click',function(){
          var current=parseInt(input.value,10)||1;
          var action=button.getAttribute('data-qty-action');
          if(action==='increase')current+=1;
          if(action==='decrease')current=Math.max(1,current-1);
          input.value=current;
          scheduleUpdate();
        });
      });
      input.addEventListener('change',function(){
        var current=parseInt(input.value,10)||1;
        input.value=Math.max(1,current);
        scheduleUpdate();
      });
    });
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initRootCart);
  }else{
    initRootCart();
  }
})();
